import React from 'react'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import InfoIcon from '@mui/icons-material/Info'
import LightbulbIcon from '@mui/icons-material/Lightbulb'

const FooterCol2 = (props) => {
  return (
    <Paper sx={{m:1, p: 1,}}>
      <Typography component="h3" fontWeight={600} variant="h6">Help</Typography>
      <List>
        {/* Learn */}
        <ListItem disablePadding>
          <ListItemButton href="/learn/">
              <ListItemIcon>
                <LightbulbIcon />
              </ListItemIcon>
              <ListItemText primary="Learn"/>
          </ListItemButton>
        </ListItem>
        {/* About Us */}
        <ListItem disablePadding>
          <ListItemButton href="/about/">
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="About Us" />
          </ListItemButton>
        </ListItem>
        {/* Contact Us */}
        <ListItem disablePadding>
          <ListItemButton href="/contact/">
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText primary="Contact Us" />
          </ListItemButton>
        </ListItem>
        {/* Pricing and Plans */}
        <ListItem disablePadding>
          <ListItemButton href="/pro/">
            <ListItemIcon>
              <Typography sx={{backgroundColor: "#b71c1c", borderRadius: 1, color: "#ffffff", px:.75,}}>Pro</Typography>
            </ListItemIcon>
            <ListItemText primary="Pricing and Plans" />
          </ListItemButton>
        </ListItem>
      </List>
    </Paper>
  )
}

export default FooterCol2